import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SubmitResponse } from '../../../models';
import { BranchApiListResponse, BranchApiRecord, BranchUpsertPayload } from '../../../models/admin/branch.model';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class BranchService extends HttpService<BranchUpsertPayload, BranchApiListResponse | BranchApiRecord> {
  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string
  ) {
    super(httpClient, apiUrl, apiVersion, 'branch');
  }

  getAllBranches(page = 1, limit?: number): Observable<BranchApiListResponse> {
    return this.getAllPaged('admin/list', page, '', limit) as Observable<BranchApiListResponse>;
  }

  getAllCustomerBranches(page = 1, limit?: number): Observable<BranchApiListResponse> {
    return this.getAllPaged('customer/list', page, '', limit) as Observable<BranchApiListResponse>;
  }

  getBranchById(id: string | number): Observable<BranchApiRecord> {
    return this.getById(id, 'admin') as Observable<BranchApiRecord>;
  }

  createBranch(payload: BranchUpsertPayload): Observable<SubmitResponse> {
    return this.create(payload);
  }

  updateBranch(id: string | number, payload: BranchUpsertPayload): Observable<SubmitResponse> {
    return this.update(payload, String(id));
  }

  updateBranchStatus(id: string | number, status: boolean): Observable<SubmitResponse> {
    return this.httpClient.patch<SubmitResponse>(`${this.apiUrl}/${id}/status`, { status });
  }

  deleteBranch(id: string | number): Observable<SubmitResponse> {
    return this.delete(String(id)) as Observable<SubmitResponse>;
  }
}
